import { render } from "./TransferCreateUpdate.vue?vue&type=template&id=4468bcc6&scoped=true"
import script from "./TransferCreateUpdate.vue?vue&type=script&lang=js"
export * from "./TransferCreateUpdate.vue?vue&type=script&lang=js"

import "./TransferCreateUpdate.vue?vue&type=style&index=0&id=4468bcc6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4468bcc6"]])

export default __exports__